import Service from "../AuthService";
// import AuthService from "../AuthServ

const Hospital = {
    getHospital() {
        return Service.get('/hospital');
    },
    getListDocctor(hospcode){
        return Service.get(`/listDoctor/${hospcode}`);
    },
    createListDocctor(data){
        return Service.post('/listDoctor',data);
    },
    updateListDocctor(data){
        return Service.put(`/listDoctor/${data.id}`,data);
    },
    deleteListDocctor(data){
        return Service.delete(`/listDoctor/${data.id}`);
    }
};


export default Hospital;
